// Components
import ServerErrorModal from '../ServerErrorModal/ServerErrorModal';
import LockoutModal from '../LockoutModal/LockoutModal';
import TimeoutModal from '../TimeoutModal/TimeoutModal';

const GlobalModals = () => (
  <>
    <ServerErrorModal />
    <LockoutModal />
    <TimeoutModal />
  </>
);

export default GlobalModals;
